/**
 * localStorage 工具函数
 * 封装群聊用户数据的持久化操作
 */

import type { StoredUser } from '../types';

const STORAGE_KEY = 'group_chat_user';

/**
 * 从 localStorage 读取已存储的用户信息
 * @returns 用户信息或 null
 */
export const loadUser = (): StoredUser | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

/**
 * 将用户信息保存到 localStorage
 * @param user 用户信息
 */
export const saveUser = (user: StoredUser): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
};

/**
 * 清除 localStorage 中的用户信息
 */
export const clearUser = (): void => {
  localStorage.removeItem(STORAGE_KEY);
};
